module.exports = __webpack_public_path__ + "static/img/102181.4ba70e9d.png";